





import Vue from "vue";
import { Component, Provide } from "vue-property-decorator";
import { ShipmentService } from "../../services/ShipmentService";

@Component({})
export default class Shipments extends Vue {
  //@Provide()
  //shipmentService =
  //	new ShipmentService(
  //		this.$store.getters['customer/customerMbeId']
  //	)
}
